import i18n from "./config";
import { getLocaleNamespaceJson } from "./builtinResources";

/**
 * Carrega namespace JSON sob demanda (mesmo require.context que buildBuiltinI18nResources).
 */
export async function ensureNamespaceLoaded(namespace) {
  ensureNamespaceLoadedSync(namespace);
}

/**
 * Versão síncrona para popups fora do MainLayout — evita useMemo capturar chaves i18n na 1ª render.
 */
export function ensureNamespaceLoadedSync(namespace) {
  const lng = i18n.resolvedLanguage || i18n.language || "pt-BR";
  if (i18n.hasResourceBundle(lng, namespace)) return;

  let data = getLocaleNamespaceJson(lng, namespace);
  if (!data && lng !== "pt-BR") {
    data = getLocaleNamespaceJson("pt-BR", namespace);
  }
  if (data) {
    i18n.addResourceBundle(lng, namespace, data, true, true);
    return;
  }
  console.warn("i18n: failed to load namespace", namespace, lng);
}

export function ensureNamespacesLoadedSync(namespaces) {
  namespaces.forEach(ensureNamespaceLoadedSync);
}
